<template>
  <div>
    <v-checkbox
      v-for="c in items"
      :key="c.ID"
      :label="c.DisplayText"
      :value="c.ID"
      multiple
      v-bind="$attrs"
      v-on="$listeners"
    >
    </v-checkbox>
  </div>
</template>

<script>
export default {
  name: "AppCheckBox",
  props: ["def", "model", "items"],
  data: function () {
    return {
      Model: this.model,
    };
  },
  created() {
    this.$set(this.Model, this.def.name, []);
  },
};
</script>
